import { createFileRoute } from '@tanstack/react-router';
import { RecentPage } from '@/features/pda/recent/recent-page';

export const Route = createFileRoute('/_app/recent')({ component: RecentPage });
